import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <div className="footer">
      <p><a href="https://awacs.ai" target="_blank" rel="noopener noreferrer"><strong>AWACS.AI</strong></a> Bicep Deployment Wizard — Built by Dustin Winkler</p>
    </div>
  );
}

export default Footer;
